// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconUserSexMale_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.03551 5.67566C7.87047 6.84726 7.7624 8.4843 6.71129 9.53542C5.53971 10.707 3.64022 10.707 2.46865 9.53542C1.29707 8.36385 1.29707 6.46435 2.46865 5.29278C3.51976 4.24166 5.1568 4.13359 6.3284 4.96855L8.29696 3L7.00403 3V2H10.004V5H9.00403V3.70714L7.03551 5.67566ZM6.00418 5.99988C5.22313 5.21884 3.9568 5.21884 3.17575 5.99988C2.3947 6.78093 2.3947 8.04726 3.17575 8.82831C3.9568 9.60936 5.22313 9.60936 6.00418 8.82831C6.78523 8.04726 6.78523 6.78093 6.00418 5.99988Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 2L14 8H12V5.77801L9.57474 8.20328C9.8468 8.74351 10 9.35386 10 10C10 12.2091 8.20914 14 6 14C3.79086 14 2 12.2091 2 10C2 7.79086 3.79086 6 6 6C6.83617 6 7.61242 6.25657 8.25431 6.69528L10.9496 4H7.99805V2H14ZM8 10C8 11.1046 7.10457 12 6 12C4.89543 12 4 11.1046 4 10C4 8.89543 4.89543 8 6 8C7.10457 8 8 8.89543 8 10Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0011 3H21.0011V9H19.0011V6.41462L15.4867 9.92899C17.5423 12.6708 17.3233 16.5777 14.8298 19.0712C12.0961 21.8049 7.66393 21.8049 4.93026 19.0712C2.19659 16.3376 2.19659 11.9054 4.93026 9.17175C7.42385 6.67816 11.3307 6.45917 14.0725 8.51477L17.5873 5H15.0011V3ZM6.34447 10.586C8.29709 8.63335 11.4629 8.63335 13.4155 10.586C15.3682 12.5386 15.3682 15.7044 13.4155 17.657C11.4629 19.6097 8.29709 19.6097 6.34447 17.657C4.39185 15.7044 4.39185 12.5386 6.34447 10.586Z" class="svg-bg"/>
</svg>
`;
/**
 * IconUserSexMale is a generated icon component.
 */
let IconUserSexMale = IconUserSexMale_1 = class IconUserSexMale extends IconBaseElement {
    render() {
        return html `${IconUserSexMale_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconUserSexMale.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconUserSexMale = IconUserSexMale_1 = __decorate([
    customElement('zui-icon-user-sex-male')
], IconUserSexMale);
export { IconUserSexMale };
